<div class="page-container" [testId]="'personal-tenant-container'">
  <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n">
    <div class="page-shell">
      <div class="page-toolbar" [testId]="'personal-tenant-header'">
        <div class="page-heading">
          <h3 class="page-title" [testId]="'personal-tenant-title'">{{ 'tenant.config.basic-info' | i18n }}</h3>
          <p class="page-subtitle" [testId]="'personal-tenant-subtitle'">{{ 'tenant.config.basic-info-subtitle' | i18n }}</p>
        </div>
        <button
          nz-button
          nzType="primary"
          type="button"
          class="save-button"
          (click)="saveInfo()"
          [nzLoading]="loading"
          [disabled]="!hasUnsavedChanges"
          [testId]="'personal-tenant-save-btn'"
        >
          <nz-icon nzType="save" [testId]="'personal-tenant-save-icon'" />
          {{ 'tenant.config.save-changes' | i18n }}
        </button>
      </div>

      <div class="unsaved-banner" *ngIf="showUnsavedStatus" [testId]="'personal-tenant-header-meta'">
        <nz-icon nzType="exclamation-circle" />
        <span>{{ 'tenant.config.unsaved-banner' | i18n }}</span>
      </div>

      <div class="form-container" [testId]="'personal-tenant-form-container'">
        <form nz-form nzLayout="vertical" [formGroup]="infoForm" class="info-form" [testId]="'personal-tenant-form'">
          <div class="form-row" [testId]="'personal-tenant-row-code-name'">
            <div class="form-col-half" [testId]="'personal-tenant-col-code'">
              <nz-form-item [testId]="'personal-tenant-code-form-item'">
                <nz-form-label [testId]="'personal-tenant-code-label'">{{ 'tenant.config.company-code' | i18n }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'tenant.config.company-code-placeholder' | i18n" [testId]="'personal-tenant-code-control'">
                  <input
                    nz-input
                    formControlName="code"
                    [placeholder]="'tenant.config.company-code' | i18n"
                    readonly
                    class="readonly-field"
                    [testId]="'personal-tenant-code-input'"
                  />
                  <div class="field-hint">{{ 'tenant.config.company-code-hint' | i18n }}</div>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="form-col-half" [testId]="'personal-tenant-col-name'">
              <nz-form-item [testId]="'personal-tenant-name-form-item'">
                <nz-form-label nzRequired [testId]="'personal-tenant-name-label'">{{ 'tenant.config.tenant-name' | i18n }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'tenant.config.tenant-name-placeholder' | i18n" [testId]="'personal-tenant-name-control'">
                  <input
                    nz-input
                    formControlName="name"
                    [placeholder]="'tenant.config.tenant-name-placeholder' | i18n"
                    [testId]="'personal-tenant-name-input'"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="form-row" [testId]="'personal-tenant-row-4'">
            <div class="form-col-half" [testId]="'personal-tenant-col-unified-number'">
              <nz-form-item [testId]="'personal-tenant-unified-number-form-item'">
                <nz-form-label [testId]="'personal-tenant-unified-number-label'">{{ 'tenant.config.unified-number' | i18n }}</nz-form-label>
                <nz-form-control [testId]="'personal-tenant-unified-number-control'">
                  <input
                    nz-input
                    formControlName="unifiedNumber"
                    [placeholder]="'tenant.config.unified-number-placeholder' | i18n"
                    [testId]="'personal-tenant-unified-number-input'"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="form-col-half" [testId]="'personal-tenant-col-website'">
              <nz-form-item [testId]="'personal-tenant-website-form-item'">
                <nz-form-label [testId]="'personal-tenant-website-label'">{{ 'tenant.config.company-website' | i18n }}</nz-form-label>
                <nz-form-control [testId]="'personal-tenant-website-control'">
                  <div class="website-input" [testId]="'personal-tenant-website-input-container'">
                    <input
                      nz-input
                      formControlName="website"
                      [placeholder]="'tenant.config.company-website-placeholder' | i18n"
                      class="website-field"
                      [testId]="'personal-tenant-website-input'"
                    />
                  </div>
                  <div class="field-hint">{{ 'tenant.config.website-hint' | i18n }}</div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="form-row" [testId]="'personal-tenant-row-5'">
            <div class="form-col-full" [testId]="'personal-tenant-col-address'">
              <nz-form-item [testId]="'personal-tenant-address-form-item'">
                <nz-form-label [testId]="'personal-tenant-address-label'">{{ 'tenant.config.company-address' | i18n }}</nz-form-label>
                <nz-form-control [testId]="'personal-tenant-address-control'">
                  <div class="address-input-group" [testId]="'personal-tenant-address-input-group'">
                    <nz-select
                      formControlName="city"
                      [nzPlaceHolder]="'tenant.config.select-region' | i18n"
                      nzAllowClear
                      class="address-select"
                      [testId]="'personal-tenant-city-select'"
                    >
                      <nz-option *ngFor="let address of addressOptions" [nzValue]="address.value" [nzLabel]="address.text" />
                    </nz-select>
                    <input
                      nz-input
                      formControlName="address"
                      [placeholder]="'tenant.config.company-address-placeholder' | i18n"
                      class="address-detail-input"
                      [testId]="'personal-tenant-address-input'"
                    />
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="form-row image-row" [testId]="'personal-tenant-row-image-header'">
            <div class="form-col-full" [testId]="'personal-tenant-col-image-header'">
              <nz-form-item [testId]="'personal-tenant-image-form-item-top'">
                <nz-form-label [testId]="'personal-tenant-image-label'">{{ 'tenant.config.company-image' | i18n }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'tenant.config.company-image-error' | i18n" [testId]="'personal-tenant-image-control-top'">
                  <div class="company-image-upload" [testId]="'personal-tenant-image-upload-container-top'">
                    <div class="image-preview" *ngIf="companyImageUrl" [testId]="'personal-tenant-image-preview-top'">
                      <img
                        [src]="companyImageUrl"
                        [alt]="'tenant.config.company-image' | i18n"
                        (click)="openImageViewer(avatarUrl)"
                        [testId]="'personal-tenant-image-preview-img-top'"
                      />
                      <button
                        class="edit-badge"
                        nz-button
                        nzType="default"
                        type="button"
                        (click)="showAvatarUploadModal()"
                        [testId]="'personal-tenant-image-edit-badge'"
                      >
                        <i nz-icon nzType="edit" nzTheme="outline"></i>
                      </button>
                    </div>
                    <div
                      class="upload-area"
                      *ngIf="!companyImageUrl"
                      (click)="showAvatarUploadModal()"
                      [testId]="'personal-tenant-image-upload-area-top'"
                    >
                      <i nz-icon nzType="plus" class="upload-icon" [testId]="'personal-tenant-image-upload-icon-top'"></i>
                      <div class="upload-text" [testId]="'personal-tenant-image-upload-text-top'">{{
                        'tenant.config.upload-file' | i18n
                      }}</div>
                    </div>
                    <div class="image-note" [testId]="'personal-tenant-image-note'">
                      <div class="image-note-title">{{ 'tenant.config.image-note-title' | i18n }}</div>
                      <div class="field-hint">{{ 'tenant.config.image-note-hint' | i18n }}</div>
                    </div>
                  </div>

                  <avatar-upload-modal
                    [(visible)]="isAvatarModalVisible"
                    [title]="'tenant.config.upload-crop-image' | i18n"
                    [uploading]="uploading"
                    [aspectRatio]="1"
                    [resizeToWidth]="300"
                    (ok)="handleAvatarUpload($event)"
                    (cancel)="handleAvatarModalCancel()"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="form-row form-row-description" [testId]="'personal-tenant-row-description'">
            <div class="form-col-full" [testId]="'personal-tenant-col-description'">
              <nz-form-item [testId]="'personal-tenant-description-form-item'">
                <nz-form-label [testId]="'personal-tenant-description-label'">{{ 'common.description' | i18n }}</nz-form-label>
                <nz-form-control [testId]="'personal-tenant-description-control'">
                  <textarea
                    nz-input
                    formControlName="description"
                    [placeholder]="'common.description-placeholder' | i18n"
                    [nzAutosize]="{ minRows: 2, maxRows: 3 }"
                    [testId]="'personal-tenant-description-textarea'"
                  ></textarea>
                  <div class="field-hint">{{ 'tenant.config.description-hint' | i18n }}</div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </form>
      </div>
    </div>
  </nz-spin>
</div>

<image-viewer
  [(visible)]="imageViewerVisible"
  [imageUrl]="companyImageUrl"
  [title]="'tenant.config.image-preview' | i18n"
  (close)="closeImageViewer()"
  [testId]="'personal-tenant-image-viewer'"
/>
